import type { EditionSummary } from '@koderek/shared';
import { Button, Group, Image, List, Paper, Stack, Text } from '@mantine/core';
import { t } from '../../texts/pl';
import { editionLabel, formatDate } from '../editions/format';

const q = t.qr;

const escapeHtml = (value: string) =>
  value.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;');

/**
 * US-601: kod QR rodziny (ekran „Kod QR”) – z nazwą edycji, datą i osobami z rodziny (AC-1), do pobrania i wydruku (AC-3).
 * Bez generowania nowego kodu (AC-4 wycofane – PRD §10 pkt 34). Obrazek z API (sesja w ciasteczku), bez tokenu w kodzie strony.
 */
export function FamilyQrPanel({ edition, people }: { edition: EditionSummary; people: string[] }) {
  const src = `/api/editions/${encodeURIComponent(edition.slug)}/registration/qr`;

  /** Wydruk samego kodu z nazwą edycji i osobami – bez reszty strony. */
  const print = () => {
    const win = window.open('', '_blank');
    if (!win) return;
    win.document.write(`<!doctype html><html lang="pl"><head><title>${escapeHtml(q.title)}</title></head>
<body style="font-family:system-ui,sans-serif;text-align:center;padding:24px">
<h1 style="font-size:22px">${escapeHtml(editionLabel(edition))}</h1><p>${escapeHtml(formatDate(edition.date))}</p>
<img src="${escapeHtml(new URL(src, window.location.origin).href)}" alt="" style="width:9cm;height:9cm" onload="window.print()">
<p>${people.map(escapeHtml).join('<br>')}</p></body></html>`);
    win.document.close();
  };

  return (
    <Paper withBorder p="lg" radius="lg" bg="var(--mantine-color-white)" shadow="xs">
      <Stack gap="md">
        <Group align="flex-start" gap="lg" wrap="wrap">
          <Image src={src} alt={q.alt(editionLabel(edition))} w={240} h={240} fit="contain" />
          <Stack gap={4}>
            <Text fw={600}>{editionLabel(edition)}</Text>
            <Text size="sm">{formatDate(edition.date)}</Text>
            <Text size="sm" fw={600} mt="xs">
              {q.people}
            </Text>
            <List size="sm">
              {people.map((name) => (
                <List.Item key={name}>{name}</List.Item>
              ))}
            </List>
          </Stack>
        </Group>
        <Group gap="xs">
          <Button component="a" href={src} download={`kod-qr-${edition.slug}.png`} variant="light" size="sm">
            {q.download}
          </Button>
          <Button variant="light" size="sm" onClick={print}>
            {q.print}
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
}
